import {Event} from 'main.core';
import {Modal} from 'asteq.modal';

export class ModalAjax extends Modal {
    constructor(params = {}) {
        super(params);
        this.loadResolve = null;
        this.loadReject = null;
        this.lastUrlLoad = null;

        this.contentEl = this.el.querySelector('[data-content]');
    }

    clearPromiseLoad() {
        this.loadResolve = null;
        this.loadReject = null;
    }

    rejectLoad() {
        if (this.loadReject) {
            this.loadReject();
        }
        this.clearPromiseLoad();
    }

    resolveLoad() {
        if (this.loadResolve) {
            this.loadResolve();
        }
        this.clearPromiseLoad();
    }

    async show(url, showParams) {
        if (this.lastUrlLoad == url) {
            this.open();
            return;
        }

        if (this.loadResolve || this.loadReject) {
            return null;
        }

        if (!this.contentEl) {
            console.error('Не установлен элемент для загрузки контента');
            return null;
        }

        const promise = new Promise((resolve, reject) => {
            this.loadResolve = resolve;
            this.loadReject = reject;
        });

        BX.ajax({
            url: url,
            method: "get",
            dataType: "html",
            processData: false,
            onsuccess: this.onSuccessContentLoaded.bind(this, showParams, url),
            onfailure: () => {
                this.rejectLoad();
                console.error('Error!')
            },
        });

        return promise;
    }

    setContent(content) {
        const processed = BX.processHTML(content);
        this.emit('onSetContentBefore');
        this.contentEl.innerHTML = processed.HTML;
        BX.ajax.processScripts(processed.SCRIPT);

        const firstChild = this.contentEl.children
            && Array.from(this.contentEl.children)
                .filter((child) => child.id)[0];

        if (firstChild) {
            Event.EventEmitter.subscribeOnce('BX.Asteq.Modal:onContentReady' + firstChild.id, () => {
                const callbackId = 'callback' + firstChild.id;
                if (window[callbackId] && typeof window[callbackId] === 'function') {
                    window[callbackId]({
                        modal: this,
                    });
                    delete window[callbackId];
                }
            });
        }

        BX.ajax.processScripts(processed.SCRIPT);

        this.emit('onSetContentAfter');
    }

    onSuccessContentLoaded(showParams, url, response) {
        if (!this.contentEl) {
            console.error('Не установлен элемент для показа контента');
            return;
        }

        this.setContent(response);
        this.lastUrlLoad = url;
        this.open();
        this.resolveLoad();
        this.open(showParams);
    }
}